<template>
  <div class="grid-view" type="primary">
    <div class="main-content">
      <div class="section operations" style="height: 39px;">
        <div class="triggers">
          <div>
            <span style="display: inline-block;width: 50px;color: #333333">{{ $t('common.btn.query') }}</span>
            <el-input
              v-model="searchConditions.likeName"
              no="likeName"
              style="width: 260px"
              size="mini"
              :placeholder="$t('Message.PleaseEnterTheCode')"
              @change="searchConditions.pageNum=1"
              @keyup.enter.native.prevent="toQuery"
            />
            <el-button no="toQuery" size="mini" type="primary" @click="toQuery">{{ $t('CargoMsg.Cargo_Query') }}</el-button>
            <el-button
              v-if="$checkPermission(['write_SMSeaPort'])"
              no="query"
              size="mini"
              type="primary"
              @click="popSeaPortAddDialog"
            >{{ $t('CargoMsg.Cargo_NewTo') }}</el-button>
            <el-button
              v-permission="['write_SMSeaPort']"
              no="editTo"
              size="mini"
              type="primary"
              @click="popSeaPortEditFormDialog"
            >{{ $t('CargoMsg.Cargo_EditTo') }}</el-button>
            <el-button
              v-permission="['write_SMSeaPort']"
              no="delete"
              size="mini"
              type="danger"
              @click="toBatchDelSeaPort"
            >{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
          </div>
        </div>
      </div>
      <div class="section grid-wrapper" style="min-height:350px">
        <cargo-ag-grid
          no="100001-grid"
          config-module="100001"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          @gridReady="onGridReady"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          v-show="searchConditions.total>0"
          no="1000011-pagination"
          config-module="1000011"
          :total="searchConditions.total"
          :page.sync="searchConditions.pageNum"
          :limit.sync="searchConditions.pageSize"
          @pagination="fetchSeaPortList"
        />
      </div>
    </div>
    <el-dialog
      v-el-drag-dialog
      no="seaportAddListDialog"
      custom-class
      :close-on-click-modal="false"
      :visible.sync="seaportAddListDialog.isShow"
      :title="$t('CargoMsg.Cargo_AddBasePort')"
      class="add-basic-seaport"
      width="800px;"
      :modal-append-to-body="false"
      @close="seaportAddListDialog.searchLikeName=''"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <div class="filters">
          <el-form :inline="true" label-width="50px" label-position="left" @submit.native.prevent>
            <div class="el-form-item-wrapper">
              <el-form-item
                :label="$t('CargoMsg.Cargo_Query')"
                :error="seaportAddListDialog.searchLikeName.length>=2?'':$t('Message.PleaseEnter')"
                :show-message="false"
              >
                <el-input
                  v-model="seaportAddListDialog.searchLikeName"
                  no="searchLikeName"
                  style="width: 260px"
                  size="mini"
                  :placeholder="$t('Message.PleaseEnterTheCode2')"
                  @keyup.enter.native.prevent="toLoadTemplatePort"
                />
              </el-form-item>
              <el-button no="toLoadTemplatePort" size="mini" type="primary" @click="toLoadTemplatePort">{{ $t('CargoMsg.Cargo_Query') }}</el-button>
            </div>
          </el-form>
        </div>
      </div>
      <div class="app-main-inner-row row-grid-dialog">
        <div style="width: 100%;display:flex;" class="cargo-ag-grid">
          <cargo-ag-grid
            no="seaportAddList-grid"
            :show-side-bar="false"
            :grid-options="seaportAddListDialog.gridOptions"
            :column-defs="seaportAddListDialogColumnDefs"
            :row-data="seaportAddListDialog.rowData"
            style="width:100%;height: 300px"
            @gridReady="onSeaportAddListDialogReady"
          />
        </div>
      </div>
      <div slot="footer">
        <el-button no="confirm" type="primary" size="mini" @click="toAddTemplatePortToPortList">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
        <el-button no="cancel" size="mini" @click="toCancelTemplateChoose">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </div>
    </el-dialog>
    <el-dialog
      v-if="isShowingSeaportForm"
      v-el-drag-dialog
      no="modifyPort"
      :close-on-click-modal="false"
      :visible.sync="isShowingSeaportForm"
      :title="$t('CargoMsg.Cargo_ModifyPort')"
      width="350px"
      :modal-append-to-body="false"
    >
      <el-form :model="oneSeaport" label-width="90px" label-position="left">
        <el-form-item :label="$t('CargoMsg.Cargo_SequenceNumber')">
          <el-input-number
            v-model="oneSeaport.serialNumber"
            no="serialNumber"
            :min="0"
            size="mini"
            style="width: calc(50% - 50px);"
            controls-position="right"
          />
        </el-form-item>
        <div style="display: flex;justify-content: space-between;">
          <div style="width: 50%;">
            <el-form-item required :label="$t('CargoMsg.Cargo_Code')">
              <el-input v-model="oneSeaport.code" no="code" size="mini" :disabled="seaportForm.isEdit" />
            </el-form-item>
          </div>
          <div style="width:calc(50% + 10px);padding-left:10px;">
            <el-form-item label>
              <el-checkbox v-model="oneSeaport.basePort" no="basePort" size="mini">{{ $t('CargoMsg.Cargo_BasePort') }}</el-checkbox>
            </el-form-item>
          </div>
        </div>
        <el-form-item :label="$t('CargoMsg.Cargo_ChineseName')">
          <el-input v-model="oneSeaport.chineseName" no="chineseName" size="mini" placeholder />
        </el-form-item>
        <el-form-item required :label="$t('CargoMsg.Cargo_EnglishName')">
          <el-input v-model="oneSeaport.englishName" no="englishName" size="mini" placeholder />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_ExchangeCode')">
          <el-input
            v-model="oneSeaport.interchangeCode"
            no="interchangeCode"
            size="mini"
            placeholder
          />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_IsoCode')">
          <el-input
            v-model="oneSeaport.isoCode"
            no="isoCode"
            :disabled="seaportForm.isEdit"
            size="mini"
            placeholder
          />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_CountryRegion')">
          <cargo-advance-select
            no="countryCode"
            :select-type="selectTypeNames.basic_data_Country"
            :callback-params="{key:'countryCode'}"
            callback-method-type="value"
            :default-value="oneSeaport.countryCode"
            filterable
            style="width:240px;"
            @parentCallBack="getValueFromChild"
          >
            <template slot-scope="{option:{item,fields}}">
              <div style="display: flex;justify-content: space-between;width:400px;">
                <div v-for="(field) in fields" :key="field" style="width:30%">{{ item[field] }}</div>
              </div>
            </template>
          </cargo-advance-select>
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_Region')">
          <cargo-advance-select
            no="region"
            filterable
            :select-type="selectTypeNames.basic_data_Region"
            :callback-params="{key:'code'}"
            callback-method-type="value"
            :default-value="oneSeaport.region"
            style="width:240px;"
            @parentCallBack="oneSeaport.region=$event.value"
          >
            <template slot-scope="{option:{item,fields}}">
              <div style="display: flex;justify-content: space-between;width:400px;">
                <div v-for="(field) in fields" :key="field" style="width:30%">{{ item[field] }}</div>
              </div>
            </template>
          </cargo-advance-select>
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_CityP')">
          <el-input v-model="oneSeaport.cityName" no="cityName" disabled style="width: 170px" />
          <el-button no="cityClick" type="primary" style="margin-left: 5px" @click="cityClickHandler">...</el-button>
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_PortRequirement')">
          <el-input
            v-model="oneSeaport.requirement"
            no="requirement"
            size="mini"
            :rows="3"
            type="textarea"
            placeholder
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button no="submitSeaPort" size="mini" type="primary" @click="submitSeaPort">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
        <el-button no="showingSeaport" size="mini" @click="isShowingSeaportForm = false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </span>
    </el-dialog>
    <location-search-dialog
      :visible.sync="cityDialogVisible"
      @addCallBack="selectLocalHandler"
      @close="cityDialogVisible=false"
    />
  </div>
</template>

<script>

import { getCountryList } from '@/api/country'
import {
  getSeaPortList,
  loadTemplatePort,
  addTemplatePort2Tenant,
  updatePort,
  getPortDetail,
  addPlatformPort,
  batchDelSeaPort
} from '@/api/seaport'

import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import URL from '@/api/urlTranslator'
import CountrySelector from '@/components/Cargo/CountrySelector'

import cargoLimitedSelect from '@/components/Cargo/Common/cargoLimitedSelect'
import { getGridSelectedIds, getGridSelected } from '@/utils/agGrid'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import LocationSearchDialog from '@/views/cargo/v0/Information/components/LocationSearchDialog'
import { getUserInfo } from '@/utils/auth'

export default {
  name: 'Port',
  components: { cargoAdvanceSelect, cargoLimitedSelect, CountrySelector, LocationSearchDialog },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      countryList: [],
      fullscreenLoading: null,
      seaportAddListDialog: {
        searchLikeName: '',
        isShow: false,
        gridOptions: {},
        rowData: [],
        gridApi: null
      },
      seqNo: 1,
      dialogInitData: {
        cityList: [],
        regionList: [],
        countryList: []
      },
      searchConditions: {
        total: 0, // total传递到后端无用
        pageNum: 1,
        pageSize: 10,
        likeName: '' // 模糊查询名称
      },
      gridOptions: {},
      gridParams: {},
      gridApi: {},
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: [],
      seaportForm: {
        isEdit: false
      },
      isShowingSeaportForm: false,
      oneSeaport: {},
      initOneSeaport: {
        basePort: false,
        chineseName: '',
        cityCode: '',
        cityName: '',
        clientRefCode: '',
        code: '',
        countryCode: '',
        createdBy: 0,
        dateCreated: '',
        dateModified: '',
        dirty: false,
        englishName: '',
        extendedData: '',
        interchangeCode: '',
        isoCode: '',
        modifiedBy: 0,
        region: '',
        requirement: '',
        serialNumber: 0,
        tenantId: 0,
        uuid: '',
        version: 1
      },
      cityDialogVisible: false,
      loading: null
    }
  },
  computed: {
    url() {
      return URL
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    columnDefs() {
      const self = this
      return [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SequenceNumber'),
          field: 'serialNumber',
          width: 80
        }, {
          headerName: this.$t('CargoMsg.Cargo_Code'),
          field: 'code',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_ChineseName'),
          field: 'chineseName',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_EnglishName'),
          field: 'englishName',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_CountryRegion'),
          field: 'countryCode',
          width: 100,
          cellRenderer: (params) => {
            const country = this.countryList.find(item => {
              return item.code === params.value
            })
            return country ? (self.isZh ? country.chineseName : country.name) : params.value
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CityCode'),
          field: 'cityCode',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_CityName'),
          field: 'cityName',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_Region'),
          field: 'regionCnName',
          width: 150,
          cellRenderer: (params) => {
            return params.data ? (self.isZh ? params.data.regionCnName : params.data.regionEnName) : ''
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_BasePort'),
          field: 'basePort',
          valueFormatter: params => {
            if (params.data.basePort) {
              return this.$t('CargoMsg.Cargo_Yes')
            } else {
              return this.$t('CargoMsg.Cargo_No')
            }
          },
          width: 80
        }, {
          headerName: this.$t('CargoMsg.Cargo_ExchangeCode'),
          field: 'interchangeCode',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_IsoCode'),
          field: 'isoCode',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_PortRequirement'),
          field: 'requirement'
        }
      ]
    },
    seaportAddListDialogColumnDefs() {
      const self = this
      return [
        {
          headerName: '', width: 60, checkboxSelection: params => {
            return !params.data.isExistPort
          },
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AlreadyAddedOrNot'),
          field: 'isExistPort',
          cellRenderer: params => {
            const iconName = !params.data.isExistPort ? 'grid-icon-enabled' : 'grid-icon-disabled'
            const color = params.data.isExistPort ? '#67c23a' : '#e6a23c'
            return `<svg class="svg-icon" fill="${color}" aria-hidden="true" style="height:1.1em;width:1.1em;">
                <use xlink:href="#icon-${iconName}"></use>
              </svg>`
          },
          width: 130
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SequenceNumber'),
          field: 'serialNumber',
          width: 80
        }, {
          headerName: this.$t('CargoMsg.Cargo_Code'),
          field: 'code',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_ChineseName'),
          field: 'chineseName',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_EnglishName'),
          field: 'englishName',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_CountryRegion'),
          field: 'countryCode',
          width: 100,
          cellRenderer: (params) => {
            const country = this.countryList.find(item => {
              return item.code === params.value
            })
            return country ? (self.isZh ? country.chineseName : country.name) : params.value
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CityCode'),
          field: 'cityCode',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_ExchangeCode'),
          field: 'interchangeCode',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_IsoCode'),
          field: 'isoCode',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_PortRequirement'),
          field: 'requirement',
          width: 200
        }
      ]
    },
    platformTenant() { // 是否平台维护
      return getUserInfo() && getUserInfo().tenantId === 1
    }
  },
  created() {
    const self = this
    self.initOneSeaport = { ...(self.oneSeaport) }
    this.seaportAddListDialog.gridOptions = {
      rowClassRules: {
        'grid-row-zebra-even': function(params) {
          return !(params.rowIndex % 2)
        },
        'grid-row-zebra-odd': function(params) {
          return (params.rowIndex % 2)
        }
      },
      rowSelection: 'multiple',
      suppressRowClickSelection: true,
      pagination: false,
      paginationPageSize: 500,
      paginationNumberFormatter: function(params) {
        return '[' + params.value.toLocaleString() + ']'
      }
    }
    this.gridOptions = {
      rowClassRules: {
        'grid-row-zebra-even': function(params) {
          return !(params.rowIndex % 2)
        },
        'grid-row-zebra-odd': function(params) {
          return (params.rowIndex % 2)
        }
      },
      rowSelection: 'multiple',
      suppressRowClickSelection: true
    }
  },
  beforeMount() {
    this.fetchSeaPortList(true)
  },
  mounted() {

  },
  methods: {
    onGridReady() {
    },
    onSeaportAddListDialogReady(params) {
    },
    // 增加模板港口到 港口列表
    toAddTemplatePortToPortList() {
      // 校验是否 已存在
      const choosePorts = getGridSelected(this.seaportAddListDialog.gridOptions)
      if (choosePorts.length <= 0) {
        this.$message.error(this.$t('Message.PleaseSelectDataBeforeOperation'))
        return
      }
      const saveList = []
      choosePorts.forEach(port => {
        if (!port.isExistPort) {
          saveList.push({
            code: port.code,
            isBasePort: port.isBasePort,
            englishName: port.englishName,
            chineseName: port.chineseName,
            countryCode: port.countryCode,
            region: port.region,
            interchangeCode: port.interchangeCode,
            isoCode: port.isoCode
          })
        }
      })
      if (saveList.length > 0) {
        addTemplatePort2Tenant(saveList).then(res => {
          this.seaportAddListDialog.isShow = false
          this.$message.success(this.$t('Message.AddSuccessfully'))
          this.fetchSeaPortList()
        }).catch(() => {
        })
      } else {
        this.$message.error(this.$t('Message.NoPortRecordMeeting'))
      }
    },
    // 取消模板port选择
    toCancelTemplateChoose() {
      this.seaportAddListDialog.isShow = false
    },
    toSetSeaportAddListDialogColumnDefs() {
      this.seaportAddListDialog.columnDefs = [
        {
          headerName: '', width: 60, checkboxSelection: params => {
            return !params.data.isExistPort
          },
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AlreadyAddedOrNot'),
          field: 'isExistPort',
          cellRenderer: params => {
            const iconName = !params.data.isExistPort ? 'grid-icon-enabled' : 'grid-icon-disabled'
            const color = params.data.isExistPort ? '#67c23a' : '#e6a23c'
            return `<svg class="svg-icon" fill="${color}" aria-hidden="true" style="height:1.1em;width:1.1em;">
                <use xlink:href="#icon-${iconName}"></use>
              </svg>`
          },
          width: 130
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SequenceNumber'),
          field: 'serialNumber',
          width: 80
        }, {
          headerName: this.$t('CargoMsg.Cargo_Code'),
          field: 'code',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_ChineseName'),
          field: 'chineseName',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_EnglishName'),
          field: 'englishName',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_CountryRegion'),
          field: 'countryCode',
          width: 100,
          cellRenderer: (params) => {
            const country = this.countryList.find(item => {
              return item.code === params.value
            })
            return country ? country.chineseName : params.value
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CityCode'),
          field: 'cityCode',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_ExchangeCode'),
          field: 'interchangeCode',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_IsoCode'),
          field: 'isoCode',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_PortRequirement'),
          field: 'requirement',
          width: 200
        }
      ]
    },
    fetchSeaPortList(forbidLoading = false) {
      if (!forbidLoading) {
        this.fullscreenLoading = getLoading()
      }

      Promise.all([getSeaPortList({ ...this.searchConditions }), getCountryList()]).then(results => {
        const seaPortRes = results[0]
        this.countryList = results[1].data
        this.searchConditions.pageNum = seaPortRes.data.pageNum
        this.searchConditions.pageSize = seaPortRes.data.pageSize
        this.searchConditions.total = Number(seaPortRes.data.total)
        this.rowData = [...seaPortRes.data.list]
      }).finally(() => {
        if (!forbidLoading) {
          this.fullscreenLoading.close()
        }
      })
    },
    toQuery() {
      this.fetchSeaPortList()
    },
    toBatchDelSeaPort() {
      const self = this
      getGridSelectedIds(this.gridOptions, 'uuid').then(ids => {
        return this.$confirm(this.$t('Message.DeleteTheSelectedRecord'), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          type: 'warning'
        }).then(() => {
          const chooseRows = getGridSelected(this.gridOptions)
          const codes = chooseRows.map(item => {
            return item.code
          })
          return batchDelSeaPort(ids, codes)
        }).catch(() => {
          return Promise.reject(this.$t('Message.DeletionCancelled'))
        })
      }).then(res => {
        if (res.ok) {
          self.fetchSeaPortList()
          this.$message({
            type: 'success',
            message: this.$t('Message.DeleteSucceeded')
          })
        } else {
          this.$message({
            type: 'info',
            message: this.$t('Message.DeleteFail')
          })
        }
      }).catch(() => {
      })
    },
    popSeaPortAddDialog() {
      // 新增弹窗 ，需要根据租户区分(tenantId==1 平台维护，tenantId=其他的)
      if (this.platformTenant) {
        this.popSeaPortAddFormDialog()
      } else {
        this.popSeaPortAddListDialog()
      }
    },
    popSeaPortAddFormDialog() {
      this.oneSeaport = { ...this.initOneSeaport }
      this.seaportForm.isEdit = false
      this.isShowingSeaportForm = true
    },
    // 新增列表弹窗
    popSeaPortAddListDialog() {
      this.seaportAddListDialog.isShow = true
      this.seaportAddListDialog.rowData = []
    },
    toLoadTemplatePort() {
      if (this.seaportAddListDialog.searchLikeName.length >= 2) {
        this.loading = getLoading4Cxt()
        loadTemplatePort(this.seaportAddListDialog.searchLikeName).then(res => {
          const portList = res.data.platform // 平台拥有港口
          const currentPortList = res.data.current // 当前租户所拥有的港口
          portList.forEach(port => {
            port.isExistPort = false

            for (let i = 0; i < currentPortList.length; i++) {
              if (currentPortList[i].code === port.code) {
                port.isExistPort = true
                break
              }
            }
          })
          this.seaportAddListDialog.rowData = [...portList]
        }).catch().finally(() => {
          this.loading.close()
        })
      }
    },
    // 编辑弹窗
    popSeaPortEditFormDialog() {
      getGridSelectedIds(this.gridOptions, 'uuid').then(ids => {
        if (ids.length !== 1) {
          this.$message.error(this.$t('Message.PleaseSelectARecordToEdit'))
        } else {
          getPortDetail(ids[0]).then(res => {
            this.oneSeaport = res.data
            this.seaportForm.isEdit = true
            this.isShowingSeaportForm = true
          }).catch(() => {
          })
        }
      })
    },
    toCheckSeaportForm(opt) {
      const { code, englishName } = { ...this.oneSeaport }
      let errorMsg = ''
      if (!code) {
        errorMsg += this.$t('Message.PleaseFillInTheCorrectFiveDigitPortCode')
      }
      if (!englishName) {
        errorMsg += this.$t('CargoMsg.Cargo_EnglishNameCanTBeEmpty')
      }
      if (errorMsg) {
        this.$message.error(errorMsg)
        return false
      } else {
        return true
      }
    },
    editSeaPort() {
      this.fullscreenLoading = getLoading()
      return updatePort(this.oneSeaport).then(res => {
        this.isShowingSeaportForm = false
        this.fullscreenLoading.close()
        this.$message({ message: this.$t('Message.PortInformationEditedSuccessfully'), type: 'success' })
      }).then(() => {
        this.fetchSeaPortList()
      }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    toAddPlatformPort() {
      addPlatformPort(this.oneSeaport).then(res => {
        this.isShowingSeaportForm = false
        this.$message({ message: this.$t('Message.SuccessfullyAddedPortInformation'), type: 'success' })
      }).then(() => {
        this.fetchSeaPortList()
      })
    },
    submitSeaPort() {
      if (!this.toCheckSeaportForm()) {
        return
      }
      if (this.platformTenant) {
        this.toAddPlatformPort()
      } else {
        this.editSeaPort()
      }
    },
    getValueFromChild(obj) {
      this.oneSeaport.countryCode = obj.value
    },
    cityClickHandler() {
      this.cityDialogVisible = true
    },
    selectLocalHandler(location) {
      this.oneSeaport.cityName = location.englishName
      this.oneSeaport.cityCode = location.code
    }
  }

}
</script>

<style scoped lang="scss">
.add-basic-seaport ::v-deep {
  .ag-paging-page-summary-panel  {
    display: flex;
  }
}
</style>
